import { render, staticRenderFns } from "./Asignados.vue?vue&type=template&id=2ffcfe17&scoped=true"
import script from "./Asignados.vue?vue&type=script&lang=js"
export * from "./Asignados.vue?vue&type=script&lang=js"
import style0 from "./Asignados.vue?vue&type=style&index=0&id=2ffcfe17&prod&scoped=true&lang=css"
import style1 from "./Asignados.vue?vue&type=style&index=1&id=2ffcfe17&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffcfe17",
  null
  
)

export default component.exports